import styled from 'styled-components';

export const StyledArrowButtonContainer = styled.div<{
  visible: boolean;
  direction: 'back' | 'forward';
}>`
  @media (min-width: ${(props) => props.theme.breakpoints.lg}px) {
    display: ${({ visible }) => (visible ? 'flex' : 'none')};
    justify-content: center;
    overflow: hidden;
    position: absolute;
    /* background: white; */
    width: 50px;
    height: 50px;
    z-index: 100;
    padding: 0 3px;
    left: ${({ direction }) => (direction === 'back' ? '0' : 'auto')};
    right: ${({ direction }) => (direction === 'forward' ? '0' : 'auto')};
  }
`;

export const Container = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  gap: var(--spacing-relative-xs);
  padding-block-start: var(--spacing-relative-xl);
  padding-block-end: 0;
  z-index: 3;
  @media (min-width: ${(props) => props.theme.breakpoints.md}px) {
    position: absolute;
    bottom: 0;
    padding-block-start: 0;
    padding-block-end: ${(props) => props.theme.spacing.sysSpaceFixed350};

    @media (min-width: ${(props) => props.theme.breakpoints.lg}px) {
      gap: var(--spacing-relative-md);
      pointer-events: none;
    }
  }
`;

export const InnerSelectorContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.colorCanvasDefault};
  background: ${({ theme }) =>
    !process.env.IS_LEGACY ? theme.colors.sysGradientElevationLevel3Fill : 'none'};
  display: flex;
  gap: 0;
  padding: 0 3px;
  scroll-behavior: smooth;
  /* transition: transform 1s cubic-bezier(0.47, 1.64, 0.41, 0.8); */
  scrollbar-width: 0;
  scrollbar-width: none;
  overflow-x: auto;
  z-index: 0;
  &::-webkit-scrollbar {
    display: none;
  }
  @media (min-width: ${(props) => props.theme.breakpoints.lg}px) {
    padding: 0 5px;
  }
`;
